"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESocialResponseType = void 0;
let ESocialResponseType = exports.ESocialResponseType = /*#__PURE__*/function (ESocialResponseType) {
  ESocialResponseType["UserNotFound"] = "userNotFound";
  return ESocialResponseType;
}({});